import { Input as AntdInput } from "antd";
import styled from "styled-components";
export const StyledTextArea = styled(AntdInput.TextArea)`
  border-radius: ${(props) => props.theme.border.radius};
`;
